import { createRouter, createWebHistory } from 'vue-router'
import AppointmentPage from '../views/AppointmentPage.vue'

const routes = [
  {
    path: '/',
    name: 'Appointment',
    component: AppointmentPage
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

export default router